var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mt-2"},[_c('div',{staticClass:"row"},[_c('CustomerInfo'),_vm._v(" "),_c('CustomerTransactions'),_vm._v(" "),_c('AccountUser',{attrs:{"id":_vm.$route.params.id}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4774664a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CustomerDetail.vue
// module id = C651
// module chunks = 1